import axios, { AxiosRequestConfig } from 'axios';
import qs from 'qs';
import BaseAppService from '../platform/base-app-service';

var url = window.location.hostname;

if (url.includes("localhost")) {
  axios.defaults.baseURL = "https://localhost:7238";
} else if (url.includes("-sand")) {
  axios.defaults.baseURL = "https://api.portalmunicipio-sand.docgedsistemas.com.br";
} else {
  axios.defaults.baseURL = "https://api.portalmunicipio.docgedsistemas.com.br";
}

axios.defaults.paramsSerializer = {
  serialize: function (params: any) {
    return qs.stringify(params, { indices: false });
  }
}

const noCache = {
  'Cache-Control': 'no-cache, no-store, must-revalidate',
  'Pragma': 'no-cache',
  'Expires': '0'
};

// Envia com o token de portal guardado (lido a cada envio: a renovação pode tê-lo trocado)
const send = (config: AxiosRequestConfig) => {
  const applicationData = BaseAppService.getApplicationData();
  config.headers = applicationData !== undefined
    ? { Authorization: `Bearer ${applicationData?.token}`, ...noCache }
    : { ...noCache };
  return axios.request(config);
};

// Uma busca de token por vez: as requisições que recebem 401 juntas esperam a mesma
let renewing: Promise<unknown> | null = null;

const renewToken = () => {
  if (!renewing) {
    renewing = BaseAppService.requestApplicationData().finally(() => {
      renewing = null;
    });
  }
  return renewing;
};

// A própria busca do token (GET Base/{empresa}) é anônima: um 401 dela não se resolve buscando outro
const isTokenRequest = (config: AxiosRequestConfig) => /^\/?Base\/\d+$/.test(config.url ?? '');

const executeRequest = async (config: AxiosRequestConfig) => {
  let result;
  try {
    result = await send(config);
  } catch (error) {
    // Token de portal expirado (vale algumas horas; a página só busca outro ao carregar): busca outro uma vez e repete a requisição
    if (!axios.isAxiosError(error) || error.response?.status !== 401 || isTokenRequest(config)) throw error;
    await renewToken();
    result = await send(config);
  }

  return { data: result.data };
};



const HttpClient = {
  executeRequest
};

export default HttpClient;
